export { ModalBackdropComponent, ModalBackdropOptions } from './modal-backdrop.component';
export { ModalDirective } from './modal.component';
export { ModalModule } from './modal.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-bootstrap/modal/index.js
// module id = 464
// module chunks = 3